<template>
    <div>
        <div v-for="item in items" :key="item.id!">
            <hr>

            <div class="xxl:gap-44 my-8 flex flex-col gap-4 sm:flex-row sm:gap-24">
                <div class="flex-1">
                    <BaseUiSkeleton v-if="loading" class="h-6 w-[7.5rem]" color="basic-dark" />
                    <BaseUiRating v-else :value="item.rating" />


                    <BaseUiSkeleton v-if="loading" class="my-4 h-6 w-40" color="basic-dark" />
                    <span v-else class="mt-4 block font-bold">
                        {{ item.getReviewerName() }}
                    </span>

                    <BaseUiSkeleton v-if="loading" class="w-18 h-6" color="basic-dark" />
                    <span v-else class="sim-reviews__date">
                        {{ item.createdAt && (new Date(item.createdAt).toLocaleDateString($i18n.locale)) }}
                    </span>
                </div>

                <div v-if="loading" class="flex w-full flex-col gap-4">
                    <BaseUiSkeleton class="h-6 w-full" color="basic-dark" />
                    <BaseUiSkeleton class="h-6 w-4/5" color="basic-dark" />
                    <BaseUiSkeleton class="h-6 w-1/2" color="basic-dark" />
                </div>
                <span v-else class="flex-2 xxl:flex-3">
                    {{ item.comment }}
                </span>
            </div>

        </div>
    </div>
</template>

<script lang="ts" setup>
import type { ProductReviewModel } from '@simploshop-models/product-review.model'

const {
    items,
    loading,
} = defineProps<{
    items: Array<ProductReviewModel>
    loading?: boolean
}>()

</script>

<style lang="scss" scoped>
.sim-reviews__date {
    display: block;

    @include sim-text-normal;
    color: $sim-c-basic-500;
}
</style>
